import dayjs from 'dayjs'

export const formatUnixAge = (value: string | number | null | undefined) => {
  if (value === undefined || value === null || value === '') return '-'
  const created = dayjs.unix(Number(value))
  if (!created.isValid()) return '-'

  const diffInHours = dayjs().diff(created, 'hour')
  if (diffInHours < 24) return `${Math.max(0, diffInHours)}h`
  return `${dayjs().diff(created, 'day')}d`
}

export const formatUnixTimestamp = (value: string | number) =>
  dayjs.unix(Number(value)).format('D MMM YYYY, HH:mm')

export const isUnixAtLeastDaysOld = (
  value: string | number | null | undefined,
  days: number,
) => {
  if (value === undefined || value === null || value === '') return false
  const created = dayjs.unix(Number(value))
  if (!created.isValid()) return false
  return dayjs().diff(created, 'day') >= days
}
